<template>
  <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M6 0C2.688 0 0 2.688 0 6C0 9.312 2.688 12 6 12C9.312 12 12 9.312 12 6C12 2.688 9.312 0 6 0ZM6.6 10.2H5.4V9H6.6V10.2ZM7.842 5.55L7.302 6.102C6.87 6.54 6.6 6.9 6.6 7.8H5.4V7.5C5.4 6.84 5.67 6.24 6.102 5.802L6.846 5.046C7.068 4.83 7.2 4.53 7.2 4.2C7.2 3.54 6.66 3 6 3C5.34 3 4.8 3.54 4.8 4.2H3.6C3.6 2.874 4.674 1.8 6 1.8C7.326 1.8 8.4 2.874 8.4 4.2C8.4 4.728 8.184 5.208 7.842 5.55Z" fill="#B2B8BF"/>
  </svg>
</template>
<script>
export default {
  name: 'IconQuestionCircle'
}
</script>